import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zones, setZones] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
      listZones();
    }
  }, [props.model]);


  return (
    <>
      <Modal
        title={`Actualizar el encargado del inventario`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='logi/inventory-manager'
        dataForce={{
          type: dataChanging.type,
          state: dataChanging.state,
          base_zone_id: dataChanging.base_zone_id,
        }}
      >
        <GridContainer>
          {/* Dni */}
          <GridItem xs={12}>
            <TextField
              label="Documento de identidad"
              fullWidth
              name="dni"
              margin="normal"
              defaultValue={dataChanging.dni || ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 8, maxLength: 11 }}
              required
            />
          </GridItem>
          {/* Celular */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Celular"
              fullWidth
              name="phone"
              margin="normal"
              defaultValue={dataChanging.phone || ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 9, maxLength: 9 }}
            />
          </GridItem>

          {/* Nombre completo */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombre completo"
              fullWidth
              name="name"
              margin="normal"
              defaultValue={dataChanging.name || ''}
              inputProps={{ minLength: 1, maxLength: 30 }}
              required
            />
          </GridItem>
          {/* FirstName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombres"
              fullWidth
              name="FirstName"
              margin="normal"
              defaultValue={dataChanging.FirstName || ''}
              required
            />
          </GridItem>
          {/* LastName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Apellidos"
              fullWidth
              name="LastName"
              margin="normal"
              defaultValue={dataChanging.LastName || ''}
              required
            />
          </GridItem>
        </GridContainer>

        {zones.length > 0 ? (
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(option) => `${option.description}`}
            value={
              zones.find(
                (item) =>
                  String(item.id) === String(dataChanging.base_zone_id)
              ) || null
            }
            renderInput={(params) => (
              <TextField {...params} label="Zonas" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {
              handleChange("base_zone_id", item.id);
            }}
            required
          />
        ) : undefined}
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            value={dataChanging.type || ''}
            inputProps={{
              name: 'type',
              onChange: (e) => handleChange('type', e.target.value),  
            }}
          >
            <MenuItem value="JD">Jefe almacen dia</MenuItem>
            <MenuItem value="JN">Jefe almacen noche</MenuItem>
            <MenuItem value="AD">Auditor</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Estado</InputLabel>
          <Select
            required
            value={ dataChanging.state}
            inputProps={{
              name: 'state',
              onChange: (e) => handleChange('state', e.target.value),
            }}
          >
            <MenuItem value="A">Activo</MenuItem>
            <MenuItem value="I">Inactivo</MenuItem>
          </Select>
        </FormControl>
      </Modal>
    </>
  );
}
